<template>
  <div v-if="!isLoaded" class="d-flex align-items-center justify-content-center w-75">
    <b-container fluid="lg">
      <h1 class="display-5 text-center mb-2 animate__animated animate__pulse animate__infinite">
        Carregando...</h1>
      <b-progress id="progress">
        <b-progress-bar id="progress-bar" :value="value" :style="{ width: value + '%' }" max="100" show-value>
          {{ value }}%
        </b-progress-bar>
      </b-progress>
      <p class="lead text-center mt-3">Conteúdo em alta resolução! Isto pode demorar um pouco, aguarde o carregamento
        completo!</p>
    </b-container>
  </div>
  <div class="w-100 d-flex align-items-center justify-content-center" v-else>
    <div id="content-pdf" class="w-100" :class="{ 'light-mode': isLightMode }">
      <div class="fixed-top mb-5">
        <div class="header-navigation shadow w-100 position-relative">
          <div class="d-flex align-items-center justify-content-around p-3">
            <button type="button" class="btn-default" v-b-tooltip.hover.bottom="'Fechar PDF'" @click="goBack">
              <i class="fa-sharp fa-regular fa-circle-xmark fa-xl"></i>
            </button>
            <div class="divider"></div>
            <button type="button" class="btn-default" @click="toggleSidebar" v-b-tooltip.hover.bottom="tooltipText">
              <i class="fa-sharp fa-regular fa-bars fa-xl"></i>
            </button>
            <span class="ml-2 title-apostila">{{ nomeApostila }}</span>
            <div class="mx-auto pageNavOverlay">
              <div class="Overlay FadeOut d-inline-flex align-items-center position-relative"
                style="top: 0; min-width: 100px; justify-content: center; opacity: 1;">
                <button type="button" class="btn-default rounded position-relative" @click="goToPreviousPage"
                  :disabled="pageNumber <= 1" v-b-tooltip.hover.bottom="'Página anterior'">
                  <i class="fa-sharp fa-solid fa-caret-left fa-xl"></i>
                </button>
                <div class="form-container h-100">
                  <input type="text" class="text-right" style="width: 28px;"
                    v-b-tooltip.hover.bottom="'Digite o número da página'" v-model="pageInput" @blur="pageNumberInput">
                  / {{ numPages }}
                </div>
                <button type="button" class="btn-default rounded position-relative" @click="goToNextPage"
                  :disabled="pageNumber >= numPages" v-b-tooltip.hover.bottom="'Próxima página'">
                  <i class="fa-sharp fa-solid fa-caret-right fa-xl"></i>
                </button>
              </div>
            </div>
            <div class="header-items">
              <div class="zoom-overlay d-flex align-items-center">
                <div class="toggle-zoom-overlay h-100" v-b-tooltip.hover.bottom="'Digite o valor do zoom'">
                  <div class="overlay-container position-relative h-100">
                    <div class="overlay-text h-100 d-flex align-items-center jusify-content-center">
                      <input type="text" class="text-area" v-model="zoom" @blur="applyZoom" style="width: 38px;"
                        tabindex="-1">
                      %
                    </div>
                  </div>
                </div>
                <button type="button" class="btn-default rounded" @click="zoomMinimus"
                  v-b-tooltip.hover.bottom="'Reduzir'">
                  <i class="fa-sharp fa-regular fa-circle-minus fa-xl"></i>
                </button>
                <button type="button" class="btn-default rounded" @click="zoomPlus"
                  v-b-tooltip.hover.bottom="'Ampliar'">
                  <i class="fa-sharp fa-regular fa-circle-plus fa-xl"></i>
                </button>
              </div>
            </div>
            <div class="divider"></div>
            <button class="btn-default rounded border-0" v-b-tooltip.hover.bottom="'Marcar página'" disabled>
              <i class="icon fa-sharp fa-regular fa-bookmark fa-xl"></i>
            </button>
            <button class="btn-default rounded boder-0"
              v-b-tooltip.hover.bottom="isLightMode ? 'Modo escuro' : 'Modo claro'" @click="toggleLightMode">
              <i :class="iconClass" class="fa-xl"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="content_pdf position-absolute">
        <div class="DocumentContainer d-flex align-items-center justify-content-center">
          <div ref="sidebar" id="sidebar" :class="[sidebarVisible ? 'sidebar-open' : '', 'position-relative']">
            <div class="d-flex align-items-center justify-content-center">
              <ul class="thumbnail-list">
                <li v-for="page in numPages" :key="page" :class="{ active: page === pageNumber }"
                  @click="goToPage(page)">
                  <canvas :ref="'thumbnail_' + page" class="thumbnail-canvas"></canvas>
                  <div class="thumbnail-info">
                    <span class="thumbnail-page-number">{{ page }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div :class="[sidebarVisible ? 'pdfViewer-sidebar' : 'pdfViewer']">
            <div class="document d-flex justify-content-center" ref="pdfContainer" :style="sidebarVisible ? 'padding: 15px 30px; width: 38.25rem; height: 49.5rem;' : 'width: 38.25rem; height: 49.5rem; padding: 15px 0; display: flex; justify-content: center;'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDocument } from 'pdfjs-dist'

export default {
  props: ['pdfUrl', 'nomeApostila'],
  data() {
    return {
      loading: true,
      value: 0,

      pdf: null,
      numPages: 0,
      pageNumber: 1,
      pageInput: 1,

      zoom: 100,

      isRedering: false,
      sidebarVisible: false,

      isLightMode: false,
      variant: 'danger',
    }
  },

  mounted() {
    this.loadPdf();
    window.addEventListener('resize', this.adjustPdfView);
    document.addEventListener('contextmenu', (event) => event.preventDefault());
    document.addEventListener('keydown', this.handleKeyDown);

    document.addEventListener('keydown', this.preventPrint);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.adjustPdfView);
    document.addEventListener('contextmenu', (event) => event.preventDefault());
    document.removeEventListener('keydown', this.handleKeyDown);

    document.removeEventListener('keydown', this.preventPrint);
  },

  computed: {
    isLoaded() {
      return this.value === 100;
    },
    iconClass() {
      return this.isLightMode === true ? 'fa-sharp fa-regular fa-moon' : 'fa-sharp fa-regular fa-sun-bright'
    },
    tooltipText() {
      return this.sidebarVisible ? 'Fechar lista de páginas' : 'Abrir lista de páginas'
    }
  },

  methods: {
    async loadPdf() {
      this.loading = true;
      this.value = 0;

      try {
        const loadingTask = getDocument(this.pdfUrl);
        loadingTask.onProgress = (progressData) => {
          if (progressData.total > 0) {
            let percent = (progressData.loaded / progressData.total) * 100;
            percent = Math.floor(percent);
            this.value = percent;
          }
        };
        const pdf = await loadingTask.promise;

        this.pdf = pdf;
        this.numPages = pdf.numPages;
        this.renderPage(this.pageNumber);
        this.loading = false;

        // window.addEventListener('keydown', this.handleKeyDown);

        document.getElementById('progress').style.visibility = 'hidden';
      } catch (error) {
        // console.error('Error loading PDF: ', error);
        this.loading = false;
        document.getElementById('progress').style.visibility = 'hidden';
      }
    },

    async renderPage(pageNum, direction) {
      const page = await this.pdf.getPage(pageNum);
      const container = this.$refs.pdfContainer
      container.innerHTML = '';

      // const desiredWidth = container.clientWidth
      // const viewport = page.getViewport({ scale: 0.72 });
      const viewport = page.getViewport({ scale: 0.8 });
      const isLandscape = viewport.width > viewport.height
      const desiredWidth = container.clientWidth;
      const scale = isLandscape ? desiredWidth / viewport.width : desiredWidth / viewport.height
      const scaledViewport = page.getViewport({ scale });

      // const scale = desiredWidth / viewport.width


      const canvas = document.createElement('canvas')
      canvas.width = scaledViewport.width;
      canvas.height = scaledViewport.height;
      const context = canvas.getContext('2d');

      const renderContext = {
        canvasContext: context,
        viewport: scaledViewport
      };

      // container.classList.add(direction === 'left' ? 'slide-in-left' : 'slide-in-right');


      // setTimeout(() => {
      //   container.classList.remove('slide-in-left', 'slide-in-right');
      // }, 1000)

      await page.render(renderContext).promise;
      this.$refs.pdfContainer.appendChild(canvas);
    },

    preventPrint(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
        event.preventDefault();
        this.$bvToast.toast('A função de imprimir está desabilitado!', {
          title: 'Error',
          variant: this.variant || 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
          toastClass: 'customElement',
          autoHideDelay: 10000,
        })
      } else if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        event.preventDefault();
        this.$bvToast.toast('A função de salvar foi desabilitado!', {
          title: 'Error',
          variant: this.variant || 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
          toastClass: 'customElement',
          autoHideDelay: 10000,
        })
      } else if (event.key === 'F12') {
        event.preventDefault();
        this.$bvToast.toast('O modo desenvolvedor foi desabilitado!', {
          title: 'Error',
          variant: this.variant || 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
          toastClass: 'customElement',
          autoHideDelay: 10000,
        })
      }
    },

    /* Função fechar o PDF */
    goBack() {
      window.history.back()
    },

    /* Função para definir se deseja ver em Dark Mode ou Light Mode */
    toggleLightMode() {
      this.isLightMode = !this.isLightMode
    },

    /* 
      A função abaixo tem finalidade de aplicar zoom ao PDF,
      ela tanto recebe um valor no input, quanto ao clicar em + ou - Zoom
      E funciona de forma dinâmica, o zoom é aplicado de acordo com os valores que forem digitados no input.
      Ao aplicar zoom nos botões o valor persiste sempre fazendo acréscimo e alterando o valor do input para +10.
    */
    applyZoom() {
      const pdfContainer = this.$refs.pdfContainer;
      if (pdfContainer) {
        const zoomValue = this.zoom / 100;
        pdfContainer.style.transform = `scale(${zoomValue})`;
        pdfContainer.style.transformOrigin = 'top center';
      }

      if (this.zoom >= 110) {
        this.sidebarVisible = false
      }

      this.zoomDisplay = `${this.zoom}`;
    },
    zoomPlus() {
      this.zoom = Math.min(6400, this.zoom + 10);
      this.applyZoom();
    },
    zoomMinimus() {
      this.zoom = Math.max(10, this.zoom - 10);
      this.applyZoom();
    },

    /* 
      A função abaixo percorrerá ao número total de páginas do pdf,
      fará com que uma navegação de avançar página e/ou página anterior nos botões seja possível no pdf,
      e ao digitar o número da página no pdf, ele leve a respectiva página desejada.
      Ambas as navegações fará com que se altere o valor no input.
    */
    async pageNumberInput() {
      const inputPageNumber = parseInt(this.pageInput.replace(/\D/g, ''));
      if (inputPageNumber >= 1 && inputPageNumber <= this.numPages) {
        this.pageNumber = inputPageNumber
        await this.renderPage(this.pageNumber);
      } else if (isNaN(inputPageNumber) || this.pageInput === '') {
        this.pageNumber = 1;
        this.pageInput = this.pageNumber;
        await this.renderPage(this.pageNumber)
      }
    },
    async goToPreviousPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
        this.pageInput = this.pageNumber;
        await this.renderPage(this.pageNumber, 'left');
      }
    },
    async goToNextPage() {
      if (this.pageNumber < this.numPages) {
        this.pageNumber++;
        this.pageInput = this.pageNumber;
        await this.renderPage(this.pageNumber, 'right')
      }
    },
    /* NAVEGAÇÃO PELO TECLADO */
    handleKeyDown(event) {
      if (this.isRedering) return;

      if (event.key === 'ArrowLeft') {
        this.isRedering = true;
        this.goToPreviousPage().finally(() => {
          this.isRedering = false;
        });
      } else if (event.key === 'ArrowRight') {
        this.isRedering = true;
        this.goToNextPage().finally(() => {
          this.isRedering = false;
        });
      }
    },

    /* 
      Sidebar do PDF
    */
    async renderThumbnails() {
      for (let pageNum = 1; pageNum <= this.numPages; pageNum++) {
        const page = await this.pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 0.5 });

        const canvas = this.$refs[`thumbnail_${pageNum}`][0];
        if (canvas) {
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          await page.render(renderContext).promise;
        }
      }
    },
    async goToPage(pageNum) {
      this.pageNumber = pageNum;
      this.pageInput = pageNum;
      await this.renderPage(pageNum)
    },
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible
      const sidebar = this.$refs.sidebar;
      if (this.sidebarVisible) {
        sidebar.classList.add('sidebar-open');
        /* Renderiza o thumbnails dos pdf's */
        this.renderThumbnails()
      } else {
        sidebar.classList.remove('sidebar-open')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  transition: background-color 0.25s ease;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.display-5 {
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: 0%;
}

.animate__animated.animate__pulse {
  --animate-duration: 3.5s;
}

#progress {
  border-radius: 32px;
}

#content-pdf {
  height: 100vh;
  background-color: #444;
  overflow: hidden;

  /* HEADER NAVIGATION PDF */
  .header-navigation {
    background-color: #333;
    z-index: 75;
    touch-action: none;
    box-sizing: content-box;

    input[type='text'] {
      color: #CCC;
    }

    .title-apostila {
      color: #CCC;
      font-size: 1rem;
      font-weight: 300;
      line-height: 22px;
      letter-spacing: 0%;
    }

    .btn-default {
      width: 2rem;
      height: 2rem;
      color: #CCC;
      cursor: pointer;
      background: transparent;
      color: #CCC;
      border: 0 solid transparent;

      &:disabled {
        color: #68747c;
        cursor: default;
      }
    }

    .divider {
      width: 1px;
      height: 20px;
      margin: 0 0.375rem;
      background: #cccccc;
    }

    .pageNavOverlay {
      height: 2rem;

      top: 0;
      left: 50%;
      bottom: 1.25rem;
      transform: translateX(-50%);

      color: #CCC;
      opacity: 0.85;

      border-radius: 6px;
      cursor: pointer;
      z-index: 0;

      background-color: #252525;

      .Overlay.FadeOut {
        opacity: 0;
        transition: opacity .3s ease;

        .form-container {
          color: #CCC;

          input {
            padding: 0;
            font-weight: 500;
            text-align: center;

            color: #CCC;
            background: transparent;

            border: 0;
            border-radius: 0;

            outline: none;
            cursor: pointer;

          }
        }
      }


    }

    .header-items {
      .btn-default {
        width: 2rem;
        height: 2rem;
        margin: 0 0.375rem;
        color: #CCC;
      }

      .zoom-overlay {
        margin: 0 0.125rem;
        height: 2rem;
        border-radius: 0.5rem;
        background-color: #333333;

        .toggle-zoom-overlay {
          color: #CCC;
          margin-right: 0.625rem;

          .overlay-container {
            width: 4.25rem;
            border-radius: 0.375rem;
            background: #252525;
            padding: 0 0.3125rem;

            .overlay-text {
              margin-right: -0.5rem;
              font-weight: 500;
              line-height: 22px;
              letter-spacing: 0%;
              border-radius: 0.25rem;

              .text-area {
                width: 3.125rem;

                resize: none;
                border: none;

                font-weight: 500;
                line-height: 22px;
                letter-spacing: 0%;

                text-align: center;

                color: inherit;
                background-color: #252525;
              }
            }
          }
        }
      }
    }
  }

  /* VIEWER PDF */
  .content_pdf {
    padding: 0;
    height: 100vh;
    background: #444;
    top: 65px;

    .DocumentContainer {
      width: 100vw;
      height: auto;
      overflow: auto;

      #sidebar {
        height: 100vh;
        padding: 30px 0 90px;
        top: 0;
        left: 0;
        overflow-y: auto;
        width: 15.625rem;
        transition: transform .3s ease;
        transform: translateX(-15.625rem);

        border-right: 1px solid #252525;

        -webkit-box-shadow: 5px 0 12px 0px rgba(37, 37, 37, .5);
        -moz-box-shadow: 5px 0 12px 0px rgba(37, 37, 37, .5);
        box-shadow: 5px 0 12px 0 rgba(37, 37, 37, .5);

        .thumbnail-list {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            padding: 4px 4px 2px;
            border: 7px solid transparent;
          }

          li.active,
          li:hover {
            margin-bottom: 10px;
            background-color: #252525;
            padding: 4px 4px 2px;
            border: 7px solid transparent;
            border-radius: 3px;
            transition: all .3s ease;
          }

          .thumbnail-canvas {
            width: 8.125rem;
            height: auto;
            background-size: cover;
            background-position: center;
          }

          .thumbnail-info {
            .thumbnail-page-number {
              font-size: 14px;
              color: #CCC;
            }
          }
        }
      }

      #sidebar.sidebar-open {
        transform: translateX(0);
      }

      .pdfViewer-sidebar {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        gap: 8px;
        transform: translateX(0);
        transition: transform .3s ease;
      }

      .pdfViewer {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0;
        transform: translateX(-5rem);
        transition: transform .3s ease;
      }

      .document {
        outline: none;
        transition: margin .3s ease-in-out;
        width: 100%;
        height: 100%;
      }
    }
  }
}

#content-pdf.light-mode {
  height: 100vh;
  overflow: hidden;

  /* HEADER NAVIGATION PDF */
  .header-navigation {
    background-color: #e0e0e0;
    border-color: #c5c5c5;
    z-index: 75;
    touch-action: none;
    box-sizing: content-box;

    input[type='text'] {
      color: #CCC;
    }

    .title-apostila {
      color: #252525;
      font-size: 1rem;
      font-weight: 300;
      line-height: 22px;
      letter-spacing: 0%;
    }

    .btn-default {
      width: 2rem;
      height: 2rem;
      color: #252525;
      cursor: pointer;
      background: transparent;
      border: 0 solid transparent;

      &:disabled {
        color: #afafaf;
        cursor: default;
      }
    }

    .divider {
      width: 1px;
      height: 20px;
      margin: 0 0.375rem;
      background: #252525;
    }

    .pageNavOverlay {
      height: 2rem;

      top: 0;
      left: 50%;
      bottom: 1.25rem;
      transform: translateX(-50%);

      color: #252525;
      opacity: 0.85;

      border-radius: 6px;
      cursor: pointer;
      z-index: 0;

      background-color: #CCC;

      .Overlay.FadeOut {
        opacity: 0;
        transition: opacity .3s ease;

        .form-container {
          color: #252525;

          input {
            padding: 0;
            font-weight: 500;
            text-align: center;

            color: #252525;
            background: transparent;

            border: 0;
            border-radius: 0;

            outline: none;
            cursor: pointer;

          }
        }
      }


    }

    .header-items {
      .btn-default {
        width: 2rem;
        height: 2rem;
        margin: 0 0.375rem;
        color: #252525;
      }

      .zoom-overlay {
        margin: 0 0.125rem;
        height: 2rem;
        border-radius: 0.5rem;
        background-color: #e0e0e0;

        .toggle-zoom-overlay {
          color: #CCC;
          margin-right: 0.625rem;

          .overlay-container {
            width: 4.25rem;
            border-radius: 0.375rem;
            background: #d4d4d4;
            padding: 0 0.3125rem;

            .overlay-text {
              margin-right: -0.5rem;
              font-weight: 500;
              line-height: 22px;
              letter-spacing: 0%;
              border-radius: 0.25rem;
              color: #252525;

              .text-area {
                width: 3.125rem;

                resize: none;
                border: none;

                font-weight: 500;
                line-height: 22px;
                letter-spacing: 0%;

                text-align: center;

                color: inherit;
                background-color: #d4d4d4;
              }
            }
          }
        }
      }
    }
  }

  /* VIEWER PDF */
  .content_pdf {
    padding: 0;
    height: 100vh;
    top: 65px;

    .DocumentContainer {
      width: 100vw;
      height: 100vh;
      overflow: auto;
      background-color: #ECECEC;

      #sidebar {
        height: 100vh;
        padding: 30px 0 90px;
        top: 0;
        left: 0;
        overflow-y: auto;
        width: 15.625rem;
        transition: transform .3s ease;
        transform: translateX(-15.625rem);

        background-color: #ECECEC;
        border-right: 1px solid #C5C5C5;

        -webkit-box-shadow: 3px 0px 12px 0px rgba(224, 224, 224, 1);
        -moz-box-shadow: 3px 0px 12px 0px rgba(224, 224, 224, 1);
        box-shadow: 3px 0px 12px 0px rgba(224, 224, 224, 1);

        .thumbnail-list {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            padding: 4px 4px 2px;
            border: 7px solid transparent;
          }

          li.active,
          li:hover {
            margin-bottom: 10px;
            background-color: #CCCCCC75;
            padding: 4px 4px 2px;
            border: 7px solid transparent;
            border-radius: 3px;
            transition: all .3s ease;
          }

          .thumbnail-canvas {
            width: 8.125rem;
            height: auto;
            border: 1px solid #c5c5c5;
            background-size: cover;
            background-position: center;
          }

          .thumbnail-info {
            .thumbnail-page-number {
              font-size: 14px;
              color: #252525;
            }
          }
        }
      }

      #sidebar.sidebar-open {
        transform: translateX(0);
      }

      .pdfViewer-sidebar {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        gap: 8px;
        transform: translateX(0);
        transition: transform .3s ease;

      }

      .pdfViewer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0;
        transform: translateX(-5rem);
        transition: transform .3s ease;
      }

      .document {
        outline: none;
        transition: margin .3s ease-in-out;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>